import { useLocation } from "react-router-dom";
import { actionProps } from "@/lib/controlAnalytics";
import { PLACES, placeAt } from "./places";
import PlaceLink from "./PlaceLink";

/**
 * The phone's places, a fixed bar along the bottom: the header's four and
 * Your envoy as the fifth, the same for everyone. Under 760 px only.
 */
export default function TabBar() {
    const { pathname } = useLocation();
    const current = placeAt(pathname);
    return (
        <nav
            aria-label="Main"
            className="tab-bar fixed inset-x-0 bottom-0 z-30 hidden border-t border-line bg-card pb-[max(8px,env(safe-area-inset-bottom))] max-[760px]:flex"
        >
            {PLACES.filter((place) => place.inTabBar).map((place) => {
                const selected = current === place.key;
                return (
                    <PlaceLink
                        {...actionProps("navigation_clicked", {
                            source: "TabBar",
                            target: place.to,
                        })}
                        key={place.key}
                        to={place.to}
                        aria-current={selected ? "page" : undefined}
                        className={`relative flex flex-1 flex-col items-center gap-[3px] px-0 pb-1.5 pt-2 text-[11px] font-semibold ${
                            selected ? "text-brand-ink" : "text-fg-muted"
                        }`}
                    >
                        {selected && <span className="tab-indicator" aria-hidden="true" />}
                        <place.icon className="size-5" />
                        {place.label}
                    </PlaceLink>
                );
            })}
        </nav>
    );
}
